/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApiKeyUsageSummary
 */
export interface ApiKeyUsageSummary {
  /**
   *
   * @type {string}
   * @memberof ApiKeyUsageSummary
   */
  apiKeyUsageSummaryId?: string;
  /**
   *
   * @type {string}
   * @memberof ApiKeyUsageSummary
   */
  apiKeyId?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof ApiKeyUsageSummary
   */
  date?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof ApiKeyUsageSummary
   */
  endpoint?: string;
  /**
   *
   * @type {number}
   * @memberof ApiKeyUsageSummary
   */
  requestCount?: number;
  /**
   *
   * @type {number}
   * @memberof ApiKeyUsageSummary
   */
  successCount?: number;
  /**
   *
   * @type {number}
   * @memberof ApiKeyUsageSummary
   */
  errorCount?: number;
}

/**
 * Check if a given object implements the ApiKeyUsageSummary interface.
 */
export function instanceOfApiKeyUsageSummary(
  value: object,
): value is ApiKeyUsageSummary {
  return true;
}

export function ApiKeyUsageSummaryFromJSON(json: any): ApiKeyUsageSummary {
  return ApiKeyUsageSummaryFromJSONTyped(json, false);
}

export function ApiKeyUsageSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiKeyUsageSummary {
  if (json == null) {
    return json;
  }
  return {
    apiKeyUsageSummaryId:
      json["apiKeyUsageSummaryId"] == null
        ? undefined
        : json["apiKeyUsageSummaryId"],
    apiKeyId: json["apiKeyId"] == null ? undefined : json["apiKeyId"],
    date: json["date"] == null ? undefined : json["date"],
    endpoint: json["endpoint"] == null ? undefined : json["endpoint"],
    requestCount:
      json["requestCount"] == null ? undefined : json["requestCount"],
    successCount:
      json["successCount"] == null ? undefined : json["successCount"],
    errorCount: json["errorCount"] == null ? undefined : json["errorCount"],
  };
}

export function ApiKeyUsageSummaryToJSON(json: any): ApiKeyUsageSummary {
  return ApiKeyUsageSummaryToJSONTyped(json, false);
}

export function ApiKeyUsageSummaryToJSONTyped(
  value?: ApiKeyUsageSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    apiKeyUsageSummaryId: value["apiKeyUsageSummaryId"],
    apiKeyId: value["apiKeyId"],
    date: value["date"],
    endpoint: value["endpoint"],
    requestCount: value["requestCount"],
    successCount: value["successCount"],
    errorCount: value["errorCount"],
  };
}
